export const joinClasses = (...classes) => classes.join(" ");
export const classesIfTrue = (classes, predicate, else_class = "") =>
  predicate ? classes : else_class;
